<template>
    <div class="email-suggestion-input">
        <ToolTip
                v-if="showTooltip"
                :icon-attrs="{ size:'16px', style: 'position: absolute; top: 1px; left: 4.5rem; color: var(--primary);' }"
                content="O e-mail desempenha um papel crucial no processo de assinatura e comunicação. <br> <br> Inclua o e-mail de seu cliente corretamente."
                icon="mdi-help-box"
                max-width="290px"
                color="black"
                bottom
        />
        <v-text-field
                class="required"
                :label="label"
                :placeholder="placeholder"
                :id="id"
                :rules="rules"
                v-model="email"
                @input="onEmailInput"
                @blur="hideSuggestions"
                @paste="onPaste"
                outlined
                :name="generateDynamicName('email')"
                autocomplete="disabled"
                :error-messages="errorMessage"

        >
        </v-text-field>
        <v-list v-if="showSuggestions" class="email-suggestions">
            <v-list-item
                    v-for="(suggestion, index) in filteredSuggestions"
                    :key="index"
                    @click="selectSuggestion(suggestion)"
            >
                <v-list-item-content>
                    <v-list-item-title>
                        <span v-html="highlightSuggestion(suggestion)"></span>
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>

  import dynamicNameMixin
    from '../../mixins/dynamicNameMixin'
  export default {
    name: 'InputEmail',
    mixins: [dynamicNameMixin],
    props: {
      value: String,
      label: {
        type: String,
        default: 'E-mail:'
      },
      placeholder: {
        type: String,
        default: ''
      },
      id: {
        type: String,
        default: 'FieldEmail'
      },
      rules: {
        type: Array,
        default: () => []
      },
      showTooltip: { type: Boolean, default: true },
      preventPaste: {
        type: Boolean,
        default: false
      },
      pasteBlockedMessage: {
        type: String,
        default: 'Por segurança, a colagem não é permitida neste campo. Digite o e-mail manualmente.'
      }
    },
    data () {
      return {
        email: this.value || '',
        emailDomains: [
          '@gmail.com',
          '@outlook.com',
          '@outlook.com.br',
          '@hotmail.com',
          '@yahoo.com',
          '@ymail.com',
          '@icloud.com'
        ],
        showSuggestions: false,
        filteredSuggestions: [],
        errorMessage: ''

      }
    },
    watch: {
      value (newValue) {
        this.email = newValue
      },
      email (newEmail) {
        this.$emit('input', newEmail)
      }
    },
    methods: {
      onPaste (event) {
        if (this.preventPaste) {
          event.preventDefault()
          this.errorMessage = this.pasteBlockedMessage
          setTimeout(() => {
            this.errorMessage = ''
          }, 3000)
        }
      },
      onEmailInput () {
        const atIndex = this.email.indexOf('@')
        if (atIndex !== -1) {
          const inputDomain = this.email.slice(atIndex)
          this.filteredSuggestions = this.emailDomains.filter((domain) =>
            domain.startsWith(inputDomain)
          )
          this.showSuggestions = this.filteredSuggestions.length > 0
        } else {
          this.showSuggestions = false
        }
      },
      hideSuggestions () {
        setTimeout(() => {
          this.showSuggestions = false
        }, 200)
      },
      highlightSuggestion (suggestion) {
        const atIndex = this.email.indexOf('@')
        const inputDomain = this.email.slice(atIndex)
        let highlightedText = ''

        for (let i = 0; i < suggestion.length; i++) {
          if (i < inputDomain.length && suggestion[i] === inputDomain[i]) {
            highlightedText += `<span style="color: green;">${suggestion[i]}</span>`
          } else {
            highlightedText += suggestion[i]
          }
        }

        return highlightedText
      },
      selectSuggestion (suggestion) {
        const atIndex = this.email.indexOf('@')
        if (atIndex !== -1) {
          this.email = this.email.substring(0, atIndex) + suggestion
        }
        this.showSuggestions = false
      }
    }
  }
</script>

<style scoped>
.email-suggestion-input {
    position: relative;
}

.email-suggestions {
    border: 1px solid #ccc;
    position: absolute;
    z-index: 10;
    background-color: white;
    width: 100%;
    left: 0;
    top: 72px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
}
</style>
